import * as Actions from './form.actions';
import { IFormsCRUD } from '../../../shared/component/filter/filter.class';
import { Action } from '@ngrx/store';

export interface FilterFormState {
  isLoading: boolean;
  isLoaded: boolean;
  data: IFormsCRUD[];
}

export const initialFilterFormState: FilterFormState = {
  isLoaded: false,
  isLoading: false,
  data: [],
};

export function filterFormReducer(state = initialFilterFormState, baseAction: Action): FilterFormState {
  const action = baseAction as Actions.FilterFormActions;

  switch (action.type) {
    case Actions.START_LOAD_FILTER_FORMS:
      return { ...state, isLoading: true };

    case Actions.FILTER_FORMS_LOADED:
      return { ...state, data: action.data, isLoaded: true, isLoading: false };

    case Actions.RESET_FORM_STORE:
      return {
        ...state,
        isLoaded: false,
        isLoading: false,
        data: [],
      };
    default:
      return state;
  }
}
